module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/report_dummy_02-0ac261197a5e3d4884bf5cc0271c5c6f.jpg";